import type { AdminCrewReportMasterFeedbackSummaryProps } from "../../models/admin-crew-report.models";

const AdminCrewReportMasterFeedbackSummary = ({ summary }: AdminCrewReportMasterFeedbackSummaryProps) => {
  if (!summary.enabled) {
    return (
      <div className="rounded border border-[#D8E6E3] bg-[#F8FBFA] px-3 py-3 text-xs text-[#596563] dark:border-gray-700 dark:bg-gray-900 dark:text-gray-300">
        <p className="font-semibold uppercase">Master correction emails</p>
        <p className="mt-1">Master correction emails are disabled for manual imports.</p>
      </div>
    );
  }

  return (
    <div className="rounded border border-[#D8E6E3] bg-[#F8FBFA] px-3 py-3 text-xs text-[#596563] dark:border-gray-700 dark:bg-gray-900 dark:text-gray-300">
      <p className="font-semibold uppercase">Master correction emails</p>
      <p className="mt-1">
        {summary.eligibleAttachments.toLocaleString()} eligible attachments; {summary.recipients.toLocaleString()}{" "}
        recipients; {summary.attempted.toLocaleString()} attempted; {summary.deliveryConfirmed.toLocaleString()}{" "}
        confirmed; {summary.deliveryUnconfirmed.toLocaleString()} unconfirmed.
      </p>
      {summary.errors.length > 0 && (
        <ul className="mt-2 list-disc space-y-1 pl-5 text-[#8F0002] dark:text-red-100">
          {summary.errors.map((error) => (
            <li key={error}>{error}</li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AdminCrewReportMasterFeedbackSummary;
